import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

export const Instructions = styled.p`
  margin-bottom: ${SPACER.xlarge};
`;

export const Disclaimer = styled.p`
  margin-bottom: ${SPACER.x3large};
  &:nth-last-of-type(2) {
    text-align: left;
  }

  ${MEDIA_QUERIES.mdUp} {
    margin-bottom: ${SPACER.x2large};
  }
`;
